import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header/header"
import Footer from "./footer/footer"

import "font-awesome/css/font-awesome.css"
import "./layout.css"
import "bootstrap/dist/css/bootstrap.css"
import "./font-face.css"
import "simple-line-icons/css/simple-line-icons.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    <div style={{ overflow: "hidden" }}>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div>
        <main>{children}</main>
        <Footer />
        <div className="footer-uiom">
          <div className="container">
            <div className="footer-grid">
              <div className="grid-33" />
              <div className="grid-33">
                <p className="p-0" style={{ fontSize: `12px` }}>
                  COPYRIGHT © 2021{" "}
                  <strong>
                    <a
                      href="https://canineortho-vetspecialty-bxj.netlify.app/"
                      target="_blank"
                      rel="noopener noferrer"
                    >
                      VETERINARY SPECIALITY CENTER
                    </a>
                  </strong>
                </p>
              </div>
              <div className="grid-33 text-right">
                <a type="button" onClick={scrollTop}>
                  <i
                    className="fa fa-2x fa-arrow-circle-o-up"
                    style={{ color: `#484848` }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
